var PES = PES || {};
PES.StickySidebarSpy = function () {
    var initialLoad = true;
    var triggeredByScrollView = false, scrollRunning = false;
    var jqSideBar, jqScrollSpy, jqAditionalNavSelector;
    var initialActiveElem;

    var selectMenuItem = function (jqTarget) {
        var jqTargetParent = jqTarget.closest('.parent');
        jqTargetParent.find('> .nav-link').addClass('active');
        jqTarget.addClass('active');
        jqTargetParent.find('.child').show();
    }

    var goToSection = function () {
        var url = window.location.href;
        var containerId = url.split("#").length > 1 ? url.split("#")[1] : "";
        if (containerId.length > 0) {
            jqSideBar.find('a.active').removeClass('active');
            var idSelector = "#" + containerId;
            var jqTarget = $('.nav-link[href="' + idSelector + '"]');
            if (jqTarget.length > 0) {
                selectMenuItem(jqTarget);
            }
        } else if (initialActiveElem) {
            var jqTarget = $(initialActiveElem);
            selectMenuItem(jqTarget);
        }
    }

    var slideAdditionalNav = function () {
        var jqCurrentNavChild = $(this).siblings('.child');
        jqAditionalNavSelector.find('.child').not(jqCurrentNavChild).slideUp();
        if ($('.inner-wrapper-sticky').hasClass('top-sticked')) {
            jqCurrentNavChild.slideToggle(PES.StickySidebar.update);
        } else {
            // animate a reverse down-sliding
            jqCurrentNavChild.slideToggle();
            jqCurrentNavChild.animate({ 'display': 'block' }, {
                step: PES.StickySidebar.update,
                duration: 400,
                queue: false,
            });
        }
    }

    var slideMenu = function (jqMenu) {
        if (!scrollRunning &&
            (jqSideBar.parent().isFullInViewport() || $('.header--generic-page').isInViewport())) {
            jqMenu.slideDown();
        }
    }

    var spyTarget = function (target) {
        var jqTarget = target.parent();
        var jqTargetParent = jqTarget.parent();

        if (initialLoad) {
            jqSideBar.find('a.active').removeClass('active');
            goToSection();
            initialLoad = false;
            return;
        }

        if (triggeredByScrollView) {
            triggeredByScrollView = false;
            return;
        }

        var jqNavChildren = jqScrollSpy.find("li .child");
        if (jqTarget.hasClass("parent") && jqTarget.find(".child").is(":hidden")) {
            jqNavChildren.not(jqTarget.find(".child")).hide();
            slideMenu(jqTarget.find(".child"));
        } else if (jqTarget.hasClass("parent") && jqTarget.find(".child").length == 0) {
            jqNavChildren.hide();
        } else if (jqTargetParent.hasClass("child") && jqTargetParent.is(":hidden")) {
            jqNavChildren.not(jqTargetParent).hide();
            slideMenu(jqTargetParent);
        }

        PES.StickySidebar.update();
    }

    function init(sideBarSelector, scrollSpySelector, aditionalNavSelector) {
        jqSideBar = $(sideBarSelector);
        jqSideBarInner = $(sideBarSelector).find('.sidebar__toc-inner');
        jqScrollSpy = $(scrollSpySelector);
        jqAditionalNavSelector = $(aditionalNavSelector);

        var jqScrollviewTarget;
        $('.scroll-view').click(function (e) {
            triggeredByScrollView = true;
            scrollRunning = true;
            jqScrollviewTarget = $(this);
        });

        $(document).ready(function (e) {
            initialActiveElem = jqSideBar.find('a.active')[0];
            jqSideBarInner.show();
            PES.StickySidebar.update();
        });

        // Init sticky sidebar
        PES.StickySidebar.init(sideBarSelector, true);            

        // Init Scoll Spy
        $('body').scrollspy({ target: scrollSpySelector });

        // Navigate to initial section
        goToSection();

        // Subscribe to spy event
        $(window).on('activate.bs.scrollspy', function (e, obj) {
            if (obj) {
                var target = $('.nav-link[href="' + obj.relatedTarget + '"]');
                spyTarget(target);
            }
        });

        // Handle the aditional nav click
        jqAditionalNavSelector.find('.parent > a').click(slideAdditionalNav);

        // Detect if scroll is running in order to skip sliding unnecessary submenus
        $(window).on('scroll', function (e) {
            if (scrollRunning) {
                scrollRunning = false;
                spyTarget(jqScrollviewTarget);
            }
        }, 250);
    }

    return {
        init: init
    };
}();